import React, { Component } from 'react'
import DatePickerUI from './DatePickerUI.js'

const timeStringToDate = (timeStr) => {
  if (timeStr.includes('T')) {
    const parsed = new Date(timeStr)
    const date = new Date()
    date.setHours(parsed.getHours(), parsed.getMinutes(), 0, 0)
    return date
  }
  const [hours, minutes] = timeStr.split(':').map(Number)
  const date = new Date()
  date.setHours(hours, minutes, 0, 0)
  return date
}

const dateToTimeString = (date) => {
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

class DatePickerSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    let selectedDate = null
    if (this.props.selectedDateISO) {
      if (this.props.showTimeSelectOnly) {
        selectedDate = timeStringToDate(this.props.selectedDateISO)
      } else {
        selectedDate = new Date(this.props.selectedDateISO)
        selectedDate = new Date(selectedDate.getTime() + selectedDate.getTimezoneOffset()*60000)
      }
    }
    // console.log('DatePickerSF', this.props.dateFormat, this.props.locale, this.props.selectedDateISO, selectedDate);

    return (
      <DatePickerUI
        context={this.props.context}
        messageList={this.props.messageList}
        selected={selectedDate}
        onChange={this.onChange}
        startOpen={this.props.startOpen}
        onClickOutside={this.props.onClickOutside}
        placeholderKey={this.props.placeholderKey}
        placeholder={this.props.placeholder}
        showTimeSelect={this.props.showTimeSelect}
        showTimeSelectOnly={this.props.showTimeSelectOnly}
        timeIntervals={this.props.timeIntervals}
        minTime={this.props.startTime ? timeStringToDate(this.props.startTime) : undefined}
        maxTime={this.props.endTime ? timeStringToDate(this.props.endTime) : undefined}
      />
    )
  }

  onChange = (date) => {
    if (!date) {
      console.log('DatePickerSF', date)
      this.props.onChange(null)
      return
    }
    if (this.props.showTimeSelectOnly) {
      this.props.onChange(dateToTimeString(date))
      return
    }
    let selectedDate = new Date(date.getTime() - date.getTimezoneOffset()*60000)
    if (this.props.showTimeSelect) {
      this.props.onChange(selectedDate.toISOString())
    } else {
      this.props.onChange(
        selectedDate.toISOString().split('T')[0]
      )
    }
  }
}

export default DatePickerSF
